export const light = `
  --secondary-font-color: #69798E;
  --primary-accent-color: #2b68b2;
  --bold-accent-color: #0C0A40;
  --bright-accent-color: #23b6ea;
  --light-grey-background: #F6F7FB;
  --grey-color: #69798E;
`;
